<template>
      <!-- header -->
      <div class="sso-home-header">
        <!-- 顶部 -->
        <div class="sso-home-header-top">
          <div class="sso-home-header-top-left">
            <img style="cursor: pointer;" @click="gohome" src="./images1/logo.png" alt="">
            <!-- 导航拦 -->
            <div class="sso-home-header-nav-wrapper">
              <!-- 导航内容块 -->
              <div class="sso-home-header-nav">
                  <div class="sso-home-header-nav-item"
                  :class="{'sso-home-header-nav-item-first': index === 0}"
                    @mouseenter="item.isHover = true"
                    @mouseleave="item.isHover = false"
                    @click="jumpLink(item,index)"
                    v-for="(item,index) of navData" :key="index"
                    v-if="item.path !== '/' || ssoUser.roleName || ssoUser.username === 'admin'">
                    <div class="nav-item-wrapper">
                      <div class="sso-nav-img" 
                        :style="{'background-image': 'url('+ require(`./images/${curNavPath === item.path || item.isHover ? item.activeImgName : item.imgName}.png`) +')'}"
                      ></div>
                      <div class="sso-nav-title" :class="{'sso-nav-title-active': curNavPath === item.path || item.isHover}">{{item.name}}</div>
                    </div>
                    <div class="line" :class="{'home-line': index === 0}" v-if="curNavPath === item.path || item.isHover"></div>
                  </div>
              </div>
              <!-- 搜索框 -->
              <div class="sso-header-search" style="display: none;">
                <div class="sso-nav-input-wrapper">
                  <input type="text" placeholder="请输入关键词" autocomplete="off" v-model.trim="search"/>
                  <!-- 搜索按钮 -->
                  <img src="./images1/sousuo.png" alt="">
                </div>

              </div>
            </div>
          </div>
          <div class="sso-home-header-top-right">
            <!-- <div class="sso-home-header-xiaoxi">
              <div class="xiaoxi-num">6</div>
            </div> -->
            <div class="sso-home-header-user-info">
              <img class="sso-header-user-img" src="./images/tx.png" alt="">
              <div class="user-info-ctx">
                <div class="user-name">{{user.username ? user.username : ''}}</div>
                <div class="user-position eplipse" :title="ssoUser.realName">{{ ssoUser.realName }}</div>
              </div>
              <div class="loginout" @click="ssoLoginOut">退出</div>
            </div>
          </div>
        </div>
       </div>
</template>
  
  <script>
  import { mapState } from 'vuex';
  export default {
    name: 'ssoHeader',
    computed:mapState(['ssoUser']),
    data() {
      return {
        curNavPath: 'ssoHome',
        navData: [
        {name:"首页",path:'ssoHome',imgName:'shouye',activeImgName:'shouye_xz',isHover: false},
        {name:"事项办理",path:'ssoSxbl',imgName:'shixiang',activeImgName:'shixiang_xz',isHover: false},
        {name:"数据融合",path:'ssoDataFusion',imgName:'ronghe',activeImgName:'ronghe_xz',isHover: false},
        {name:"信息报送",path:'ssoNewsReport',imgName:'xinwen',activeImgName:'xinwen_xz',isHover: false},
        {name:"应用监测",path:'ssoStatistic',imgName:'yingyong',activeImgName:'yingyong_xz',isHover: false},
        {name:"系统管理",path:'/',imgName:'xitong',activeImgName:'xitong_xz',isHover: false},
        ],
        search: '',
        user: {}
      };
    },
  created() {
    Promise.all([
      this.getSsoUser(),
      this.getPermissions()
    ]).then(() => {
      this.loading = false
    })
    
    this.curNavPath = this.$route.name

  },
  watch:{
    $route () {
      this.curNavPath = this.$route.name
    }
  },
  methods: {
    gohome(){
      this.$router.push('/sso')
    },
    getSsoUser(){
       return this.$http({
        url: this.$http.adornUrl('/sso/getUser?xxl_sso_sessionid=' + localStorage.getItem("xxl_sso_sessionid")),
        method: 'get'
        }).then(({data}) => {
          if (!data.data) { // 跳转到登录页
            this.$router.push("ssoLogin")
          }
          this.user = data.data
          this.$store.commit('setSsoUser',data.data)
        }).catch(() => {})
      },
          // 获取权限
      getPermissions () {
        if (!localStorage.getItem("xxl_sso_sessionid")) {
          return;
        }
        return this.$http.get(this.$http.adornUrl('/sys/user/permissions?xxl_sso_sessionid=' + localStorage.getItem("xxl_sso_sessionid"))).then(({ data: res }) => {
          if (res.code !== 0) {
            // return this.$message.error(res.msg)
          }
          window.SITE_CONFIG['permissions'] = res.data
        }).catch(() => {})
      },
      ssoLoginOut(){ // 自由统一登录 退出
        this.$http({
        url: this.$http.adornUrl('/sso/loginOut'),
        method: 'get'
        }).then(({data}) => {
          if (data.code === 200) { // 跳转到登录页
            window.localStorage.removeItem('xxl_sso_sessionid')
            this.$router.push("ssoLogin")
          }
        })
      },
      jumpLink(item,index) {
        this.curNavIndex = index + 1
        if (item.name === '系统管理') { // 跳转系统后台
          window.open("https://zscqj.hubei.gov.cn/ipscm/#/home?xxl_sso_sessionid=" + localStorage.getItem("xxl_sso_sessionid"),"_blank")
        }else {
          this.$router.push(item.path)
        }
        
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
    .sso-home-header {
        width: 100%;
        height: 72px;
        background-color: #2E79E8;
        .sso-home-header-top {
          display: flex;
          justify-content: space-between;
          height: inherit;
          &-left {
            margin-top: 13px;
            margin-left: 50px;
            display: flex;
            img {
                width: 348px;
                height: 54px;
                margin-right: 120px;
            }
            .sso-home-header-nav-wrapper {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .sso-home-header-nav {
                display: flex;
              .sso-home-header-nav-item {
                  cursor: pointer;
                  width: 160px;
                  height: 50px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  img {
                    width: 28px;
                    height: 28px;
                    margin-right: 4px;
                  }
                  .nav-item-wrapper {
                    display: flex;
                    align-items: center;
                    .sso-nav-img {
                      width: 32px;
                      height: 32px;
                      background-size: 100% 100%;
                      background-position: center;
                      background-repeat: no-repeat;
                      margin-right: 4px;
                    }
                    .sso-nav-title {
                      font-family: Source Han Sans CN;
                      font-weight: 400;
                      font-size: 18px;
                      color: #FFFEFE;
                      opacity: 0.8;
                    }
                  }
                  .line {
                    margin-top: 10px;
                    width: 110px;
                    height: 4px;
                    background: #FFFFFF;
                  }
                  .home-line {
                    width: 73px;
                  }
                  .sso-nav-title:hover,.sso-nav-title-active {
                    font-weight: 800;
                    opacity: 1;
                  }
                }
                .sso-home-header-nav-item-first {
                  width: 120px;
                }
              }
              .sso-header-search {
              margin-right: 27px;
              display: flex;
              width: 200px;
              height: 36px;
              background: #FFFFFF;
              border-radius: 8px;
              border: 1px solid #E6E6E6;
              box-sizing: border-box;
              .sso-nav-input-wrapper {
                position: relative;
                input {
                  width: 200px;
                  font-size: 15px;
                  border: unset;
                  background: #fff;
                  border-radius: 8px;
                  text-indent: 39px;
                  line-height: 32px;
                  box-sizing: border-box;
                }
                input::placeholder {
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 15px;
                  color: #646464;
                }
                input:focus {
                  outline: unset;
                }
                img {
                  position: absolute;
                  right: 16px;
                  top: 8px;
                  width: 20px;
                  height: 20px;
                  margin-right: 0;
                  cursor: pointer;
                }
              }
              }
            }
          }
          &-right {
          margin-top: 22px;
          display: flex;
          .sso-home-header-xiaoxi {
              cursor: pointer;
              width: 28px;
              height: 37px;
              background-image: url('./images/xiaoxi.png');
              background-size: 100% 100%;
              background-position: center;
              background-repeat: no-repeat;
              position: relative;
              .xiaoxi-num {
              position: absolute;
              top: 0;
              right: -14px;
              width: 20px;
              height: 20px;
              background: #D2060E;
              border-radius: 50%;
              border: 2px solid #FFFFFF;
              display: flex;
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 14px;
              align-items: center;
              justify-content: center;
              color: #fff;
              }
          }
          .sso-home-header-user-info {
              display: flex;
              margin-right: 51px;
              margin-left: 65px;
              .loginout {
                cursor: pointer;
                color: #fff;
                font-family: Source Han Sans CN;
                font-weight: bold;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                justify-content: center;
              }
              .sso-header-user-img {
              width: 40px;
              height: 40px;
              }
              .user-info-ctx {
              margin-left: 10px;
              margin-right: 10px;
              font-family: Source Han Sans CN;
              color: #FFFFFF;
              .user-name {
                  margin-bottom: 6px;
                  height: 16px;
                  line-height: 16px;
                  font-weight: 500;
                  font-size: 16px;
              }
              .user-position {
                  height: 13px;
                  line-height: 13px;
                  font-weight: 400;
                  font-size: 13px;
              }
              }
          }
          }
        }
    }
  </style>